const StorageHelper = {
  getItem(key) {
    const storedValue = localStorage.getItem(window.location.origin + key)
    if (!storedValue) return null

    try {
      return JSON.parse(storedValue)
    } catch (error) {
      console.error(`Error al parsear ${key} desde localStorage:`, error)
      return null
    }
  },
  setItem(key, data) {
    localStorage.setItem(window.location.origin + key, JSON.stringify(data))
  },
  removeItem(keys) {
    keys.forEach((key) => localStorage.removeItem(window.location.origin + key))
  },
}

const Session = {
  getSession() {
    return StorageHelper.getItem('_auth')
  },

  setSession(data) {
    StorageHelper.setItem('_auth', data)
  },

  getToken() {
    const session = this.getSession()
    if (session?.token) return session.token

    this.removeSession()
    return null
  },

  getRefreshToken() {
    const session = this.getSession()
    if (session?.refresh_token) {
      return session.refresh_token
    }
    this.removeSession()
    return null
  },

  setToken(token) {
    const session = this.getSession()
    if (!session) return
    session.token = token
    this.setSession(session)
  },

  removeSession() {
    StorageHelper.removeItem(['_auth', '_authAll', '_menu', '_paramGenerales'])
  },

  clear() {
    this.removeSession()
  },
}

const SessionAll = {
  getSessions() {
    return StorageHelper.getItem('_authAll')
  },
  setSessions(data) {
    StorageHelper.setItem('_authAll', data)
  },
  removeSessions() {
    StorageHelper.removeItem(['_auth', '_authAll'])
    // 🚫 Ya no redirige. Que lo haga el componente que lo llame.
  },
}

const Menu = {
  getMenu() {
    return StorageHelper.getItem('_menu')
  },
  setMenu(data) {
    StorageHelper.setItem('_menu', data)
  },
  removeMenu() {
    StorageHelper.removeItem(['_menu'])
  },
}

const ParamGenerales = {
  getParamGenerales() {
    const paramGenerales = StorageHelper.getItem('_paramGenerales') || []
    if (!Array.isArray(paramGenerales)) return []

    return paramGenerales.reduce((acc, element) => {
      Object.entries(element).forEach(([clave, valor]) => {
        acc[clave] = valor
      })
      return acc
    }, {})
  },
  setParamGenerales(data) {
    StorageHelper.setItem('_paramGenerales', data)
  },
  removeParamGenerales() {
    StorageHelper.removeItem(['_paramGenerales'])
  },
  
  // ✅ Nuevo método: actualizar un solo parámetro
  updateParametro(clave, nuevoValor) {
    // obtener array original del storage
    const data = StorageHelper.getItem('_paramGenerales') || []

    // buscar si existe la clave
    const index = data.findIndex(p => Object.keys(p)[0] === clave)

    if (index !== -1) {
      data[index][clave] = nuevoValor
    } else {
      // si no existe, lo agrega
      data.push({ [clave]: nuevoValor })
    }

    // guardar nuevamente
    StorageHelper.setItem('_paramGenerales', data)
  },
}

const UrlBase = {
  getUrlBase() {
    return StorageHelper.getItem('_urlBase')
  },
  setUrlBase(data) {
    StorageHelper.setItem('_urlBase', data)
  },
  removeUrlBase() {
    StorageHelper.removeItem(['_urlBase'])
  },
}

const wsBase = {
  getWsBase() {
    return StorageHelper.getItem('_wsBase')
  },
  setWsBase(data) {
    StorageHelper.setItem('_wsBase', data)
  },
  removeWsBase() {
    StorageHelper.removeItem(['_wsBase'])
  },
}

const Dashboard = {
  getDashboard() {
    return StorageHelper.getItem('_dashboard')
  },
  setDashboard(data) {
    StorageHelper.setItem('_dashboard', data)
  },
  removeDashboard() {
    StorageHelper.removeItem(['_dashboard'])
  },
}

function actualizarSoloToken(nuevoToken) {
  const sessionActiva = Session.getSession()
  const todasLasSesiones = SessionAll.getSessions()

  if (!sessionActiva || !todasLasSesiones) return

  // 1. Reemplazar token en la sesión activa (_auth)
  sessionActiva.token = nuevoToken
  Session.setSession(sessionActiva)

  // 2. Reemplazar token en la lista de sesiones (_authAll)
  const sesionesActualizadas = todasLasSesiones.map((sesion) => {
    return sesion.domain === sessionActiva.domain
      ? { ...sesion, token: nuevoToken }
      : sesion
  })

  SessionAll.setSessions(sesionesActualizadas)
}

export { Session, SessionAll, Menu, ParamGenerales, UrlBase, Dashboard, wsBase, actualizarSoloToken }
